import React from "react";
import Alert from "@mui/material/Alert";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import LegalbirdAuthenticatedLoaderPage from "@/src/containers/Pages/Loading/LegalbirdAuthenticatedLoaderPage";
import Error404Page from "@/src/containers/Pages/Generic/Error404/Error404Page";
import CaseMessages from "@/src/components/Messaging/MessageCenter/CaseMessages";
import EmailVerificationModal from "@/src/components/FormInfoModal/EmailVerificationModal";
import { useBasicAccountData } from "@/src/provider/BasicAccountData/BasicAccountDataProvider";

export default function CaseMessagesPage() {
  const { caseId } = useParams();
  const { minimalCases, conversations, isLoading, isError } = useBasicAccountData();

  if (isLoading) {
    return <LegalbirdAuthenticatedLoaderPage />;
  }

  if (isError || !minimalCases || !conversations) {
    return (
      <LayoutProtectedRoutes>
        <Alert severity={"error"}>Die Nachrichten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.</Alert>
      </LayoutProtectedRoutes>
    );
  }

  const selectedCase = minimalCases.find((minimalCase) => String(minimalCase.id) === caseId);
  if (!selectedCase) {
    return <Error404Page />;
  }

  return (
    <LayoutProtectedRoutes>
      <Helmet>
        <title>Servicewelt Nachrichtenübersicht | Legalbird</title>
      </Helmet>
      <CaseMessages key={selectedCase.id} selectedCase={selectedCase} conversations={conversations} />
      <EmailVerificationModal />
    </LayoutProtectedRoutes>
  );
}
